export const Facebook = () => (
  <svg height="100%" viewBox="0 0 20 44" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.5283 44H13.2075V21.8087H19.2453L19.8113 14.3478H13.2075C13.2075 14.3478 13.2075 11.4783 13.2075 10.1391C13.2075 8.41739 13.5849 7.65217 15.283 7.65217C16.6038 7.65217 20 7.65217 20 7.65217V0C20 0 15.0943 0 13.9623 0C7.54717 0 4.5283 2.86957 4.5283 8.41739C4.5283 13.2 4.5283 14.3478 4.5283 14.3478H0V21.8087H4.5283V44Z"
      fill="#112CAE"
    />
  </svg>
);
